import { EnumModuleType } from '@/src/types/common/module';
import { not_editable as contentCarousel } from './contentCarousel';
import { not_editable as contentGrid } from './contentGrid';
import { not_editable as contentTab } from './contentTab';
import { not_editable as iframe } from './iframe';
import { not_editable as imageCarousel } from './imageCarousel';
import { not_editable as poster } from './poster';
import { not_editable as posterTab } from './posterTab';
import { not_editable as productCarousel } from './productCarousel';
import { not_editable as productGrid } from './productGrid';
import { not_editable as productTab } from './productTab';
import { not_editable as subscription } from './subscription';
import { not_editable as text } from './text';

export default (moduleType: EnumModuleType) => {
  switch (moduleType) {
    case EnumModuleType.ResponsiveImageCarousel:
      return imageCarousel;
    case EnumModuleType.ResponsiveContentCarousel:
      return contentCarousel;
    case EnumModuleType.ResponsiveProductCarousel:
      return productCarousel;
    case EnumModuleType.ResponsiveContentGrid:
      return contentGrid;
    case EnumModuleType.ResponsiveProductGrid:
      return productGrid;
    case EnumModuleType.ResponsivePosterTab:
      return posterTab;
    case EnumModuleType.ResponsiveContentTab:
      return contentTab;
    case EnumModuleType.ResponsiveProductTab:
      return productTab;
    case EnumModuleType.ResponsiveText:
      return text;
    case EnumModuleType.ResponsivePoster:
      return poster;
    case EnumModuleType.ResponsiveSubscription:
      return subscription;
    case EnumModuleType.ResponsiveIframe:
      return iframe;
    default:
      return [];
  }
};
